// @flow
import momentTimezone from 'moment-timezone';
import { authenticatedFetch } from '../../../api/request';

export default async function getNotificationSettings() {
    const tzName = encodeURIComponent(momentTimezone.tz.guess());
    return await authenticatedFetch(
        `/v5/notifications/settings?tzName=${tzName}`
    );
}
